var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-paypal',
                        view: publicPath + 'sprite.svg#view-icon-paypal',
                        viewBox: '0 0 62 18',
                        title: 'paypal icon',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };